import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Layout, Stack, Spinner} from '@shopify/polaris';
import Step from './step';
import Summary from './summary';
import Confirmation from './confirmation';
import ConfirmationInvite from './confirmationInvite';
import {generateSummary} from './helpers/summary';
import {setOrganization} from '../../actions/context';
import {isTestMode} from './helpers/test_mode';

class QuestionsFlow extends React.PureComponent {
  render() {
    return <Layout>{this.renderStep()}</Layout>;
  }

  renderConfirmationPage() {
    const {organization} = this.props;

    return organization && isTestMode() ? (
      <ConfirmationInvite />
    ) : (
      <Confirmation />
    );
  }

  renderStep() {
    const {
      currentStepId,
      fetchingStep,
      completedSteps,
      steps,
      submitted,
    } = this.props;

    if (fetchingStep) {
      return (
        <Layout.Section>
          <Stack distribution="center">
            <Spinner />
          </Stack>
        </Layout.Section>
      );
    } else if (submitted) {
      return this.renderConfirmationPage();
    } else if (completedSteps) {
      return <Summary summary={generateSummary()} />;
    } else if (steps[currentStepId]) {
      return <Step stepId={currentStepId} />;
    } else {
      return null;
    }
  }
}

function mapStateToProps(store) {
  const {
    progress: {currentStepId, fetchingStep, completedSteps, submitted},
    entities: {steps},
    context: {organization, serviceHandle},
  } = store;

  return {
    currentStepId,
    fetchingStep,
    completedSteps,
    steps,
    organization,
    serviceHandle,
    submitted,
  };
}

const mapDispatchToProps = {
  setOrganization,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionsFlow);

QuestionsFlow.propTypes = {
  currentStepId: PropTypes.string,
  fetchingStep: PropTypes.bool,
  completedSteps: PropTypes.bool,
  steps: PropTypes.object.isRequired,
  submitted: PropTypes.bool,
};
